import { installResizeObserverLoopErrorSuppressor } from './suppress-resize-observer-loop-error'

installResizeObserverLoopErrorSuppressor()
